import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Typography, TextField, Dialog, DialogTitle, DialogActions, DialogContent } from "@material-ui/core";

import toJs from "../../../../hoc/toJS";
import select from "../../../../utils/select";
import ROUTER from "../../../../constants/router";

import KPTable from "../../../../components/KPTable";

import { updateTimeResearchDetail } from "../../../../reducer/timeResearchInformation/action";
import { is } from "immutable";

function ResearchTimeTable(props) {
  const [open, setOpen] = React.useState(false);
  const [editting, setEditting] = useState(null);

  useEffect(() => {
    if (props.history !== null && props.role !== "sudo-admin") props.history.push(ROUTER.HOME);
  }, []);

  useEffect(() => {
    setEditting(null);
  }, [props.timeResearchInformationList]);

  const handleClose = () => setOpen(false);
  const handleClickOpen = () => setOpen(true);

  const handleSumit = (e) => {
    e.preventDefault();

    const index = props.timeResearchInformationList.find((e) => e.year === props.year).id;

    const temp = props.timeResearchInformationList.find((e) => e.year === props.year)?.timeResearchDetail;
    const id = temp.findIndex((e) => e.id === editting.id);
    temp.splice(id, 1, editting);

    // props.updateTimeResearchDetail(index, {
    //   ...props.timeResearchInformationList.find((e) => e.year === props.year),
    //   timeResearchDetail: temp,
    // });

    props.updateTimeResearchDetail(index, {
      ...temp.find((e) => e.id === editting.id),
    });

    setEditting(null);
  };

  const handleChange = (value) =>
    setEditting({
      ...editting,
      value: value,
    });

  const list = props.timeResearchInformationList.find((e) => e.year === props.year)?.timeResearchDetail || [];

  // console.log("list", list);

  return (
    <>
      <KPTable
        shadow="none"
        rowsPerPage={20}
        maxHeight="calc(100vh - 300px)"
        loading={props.isFetching}
        columns={[
          {
            title: <b>STT</b>,
            key: "stt",
            width: "5%",
          },
          {
            title: <b>Nhiệm vụ</b>,
            key: "description",
            width: "60%",
          },
          {
            title: <b>Số giờ NCKH</b>,
            key: "value",
            width: "15%",
            sorter: (a, b) => a.value - b.value,
            render: (value, row) => {
              if (editting?.id === row.id) {
                return (
                  <form onSubmit={(event) => handleSumit(event)}>
                    <TextField
                      autoFocus
                      fullWidth
                      size="small"
                      type="number"
                      variant="outlined"
                      value={editting.value}
                      onChange={(event) => handleChange(parseInt(event.target.value))}
                    />
                  </form>
                );
              }
              return value;
            },
          },
          {
            title: <b>Tác vụ</b>,
            key: "action",
            width: "20%",
            render: (value, row) => (
              <>
                {editting?.id !== row.id ? (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => setEditting(row)}
                  >
                    Sửa
                  </Typography>
                ) : (
                  <>
                    <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSumit}>
                      Lưu
                    </Typography>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="secondary"
                      onClick={() => setEditting(null)}
                    >
                      Huỷ
                    </Typography>
                  </>
                )}
              </>
            ),
          },
        ]}
        rows={list.sort((a, b) => a.stt - b.stt)}
      />

      <Button color="primary" variant="contained" style={{ left: 16, bottom: 44 }} onClick={handleClickOpen}>
        Chú thích
      </Button>

      <Dialog maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Chú thích
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            <b>1. Bài báo khoa học</b>
          </Typography>
          <Typography gutterBottom>
            - Trường hợp chọn mục đích Tính giờ nghiên cứu, bắt buộc lựa chọn Nhiệm vụ và nhập Số giờ quy đổi riêng theo công thức: 0,01 điểm công trình khoa học tương đương 02 giờ nghiên cứu, hệ thống không áp dụng số giờ mặc định của nhiệm vụ.
          </Typography>
          <Typography gutterBottom>
            - Giờ nghiên cứu được phân bổ như sau: 1/3 tổng điểm công trình chia cho các tác giả chính. 2/3 tổng điểm còn lại chia đều cho toàn bộ tác giả (bao gồm tác giả chính).
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo tháng/năm được chấp nhận.
          </Typography>
          <br />
          
          <Typography variant="h6" gutterBottom>
            <b>2. Giải pháp hữu ích, Bằng sáng chế</b>
          </Typography>
          <Typography gutterBottom>
            - Giờ nghiên cứu được phân bổ như sau: Tác giả chính/Hướng dẫn chính được hưởng 1/2 tổng điểm quy đổi. 1/2 tổng điểm còn lại được chia đều cho các thành viên tham gia. Tổng số giờ phân bổ cho các thành viên không vượt quá số giờ của nhiệm vụ.
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo ngày cấp bằng.
          </Typography>
          <br />
          
          <Typography variant="h6" gutterBottom>
            <b>3. Đề tài nghiên cứu</b>
          </Typography>
          <Typography gutterBottom>
            - Giờ nghiên cứu được phân bổ như sau: Chủ nhiệm đề tài hưởng 1/2 số giờ quy đổi của đề tài. Thư ký khoa học hưởng 1/4 số giờ quy đổi. 1/4 số giờ còn lại được chia đều cho các thành viên. Tổng số giờ phân bổ không vượt quá số giờ của nhiệm vụ.
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo ngày nghiệm thu.
          </Typography>
          <br />
          
          <Typography variant="h6" gutterBottom>
            <b>4. Sách</b>
          </Typography>
          <Typography gutterBottom>
            - Giờ nghiên cứu được phân bổ như sau: Các thành viên tự đề xuất số giờ nghiên cứu. Tổng số giờ phân bổ không vượt quá 700 giờ.
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo tháng/năm xuất bản.
          </Typography>
          <br />
          
          <Typography variant="h6" gutterBottom>
            <b>5. Triển lãm</b>
          </Typography>
          <Typography gutterBottom>
            - Giờ nghiên cứu được phân bổ như sau: Hướng dẫn chính/Tác giả chính hưởng 1/2 tổng điểm. 1/2 tổng điểm còn lại được chia đều cho các thành viên.
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo thời gian tổ chức.
          </Typography>
          <br />
          
          <Typography variant="h6" gutterBottom>
            <b>6. Hướng dẫn sinh viên</b>
          </Typography>
          <Typography gutterBottom>
            - Hướng dẫn chính hưởng 1/2 tổng điểm. 1/2 tổng điểm còn lại được chia đều cho các thành viên.
          </Typography>
          <Typography gutterBottom>
            - Thời điểm tính giờ: theo ngày hoàn thành.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleClose}>
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  year: select(state, "timeResearchInformationReducer", "year"),
  yearFilter: select(state, "timeResearchInformationReducer", "yearFilter"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetching: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  updateTimeResearchDetail: (id, payload) => dispatch(updateTimeResearchDetail(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ResearchTimeTable));

